<template>
  <div :class="title ? 'border-2 border-primary-400' : ''">
    <div v-if="title" class="flex items-center text-primary-400 border-b-2 border-primary-400">
      <PatternBase class="hidden shrink-0 -m-0.5 w-[120px] h-[120px] shadow-pattern shadow-current stroke-2 md:block" />
      <h3 class="p-4 ml-0.5 text-mobile-xl font-semibold md:px-6 md:text-xl">
        {{ $t(title) }}
      </h3>
    </div>
    <div class="max-w-none prose-a:no-underline prose prose-shade" :class="title ? 'px-4 pt-4 md:px-10 md:pt-10' : ''">
      <div>
        <slot name="excerpt"></slot>
      </div>
      <transition enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform -translate-y-4 opacity-0"
        enter-to-class="transform translate-y-0 scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-out"
        leave-from-class="transform translate-y-0 scale-100 opacity-100"
        leave-to-class="transform -translate-y-4 opacity-0">
        <div v-if="showMore">
          <slot></slot>
        </div>
      </transition>
    </div>
    <div v-if="!hideShowMore">
      <button
        class="flex gap-2 items-center mt-4 font-sans font-semibold text-primary-400 hover:text-shade-900 transition-colors duration-200 ease-out md:mt-6"
        :class="title ? 'px-4 pb-4 md:px-10 md:pb-10' : ''" @click="toogleShowMore">
        <span v-if="!showMore" class="first-letter:uppercase">
          {{ $t('labels.read_more') }}
        </span>
        <span v-else class="first-letter:uppercase">
          {{ $t('labels.read_less') }}
        </span>
        <ChevronDown v-if="!showMore" class="w-4 h-4" />
        <ChevronUp v-else class="w-4 h-4" />
      </button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import ChevronDown from '~/assets/icon/navigation/Chevron/Down.svg'
import ChevronUp from '~/assets/icon/navigation/Chevron/Up.svg'
const props = defineProps({
  title: {
    type: String,
  },
  hideShowMore: {
    type: Boolean,
    default: false,
  },
})

const showMore = ref<boolean>(false)
const toogleShowMore = () => {
  showMore.value = !showMore.value
}
</script>
